import { getStoreId } from "$/hooks/use-store-information"
import customerQueries from "$/lib/queries/job-customer-queries"
import { requireStoreModule } from "$/lib/require-store-module"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/customer-club/")({
  loader: async ({ context: { queryClient } }) => {
    await requireStoreModule(queryClient, "customerClubEnabled")
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(customerQueries.list({ storeId }))
      queryClient.prefetchQuery(customerQueries.club(storeId))
    }
    return {
      crumb: "alfred.pages.customerClub.crumbs.customerClub",
    }
  },
})
